export interface SocialNetwork {
  id: number;
  name: string;
  code: string | null;
  logo: string | null;
}

export interface FarmSocialNetwork extends SocialNetwork {
  pivot: {
    url: string;
  };
}

export interface FarmSocialPost {
  id: number;
  social_network_id: number;
  permalink: string | null;
  image: string;
  posted_at: string | null;
}

export const toSocialLinkValues = (
  networks?: FarmSocialNetwork[] | null
): Record<string, string> =>
  Object.fromEntries(
    (networks ?? []).map((network) => [String(network.id), network.pivot.url])
  );
